import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-top: ", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var headerFooterInset = css(_templateObject(), ui.space(2), ui.space(2));
export var ListGroupFooter = css(_templateObject2(), ui.space(1));